export default __webpack_public_path__ + "static/legal-general-951f1ef60d18afb5d2aed7ce39f360f8.png";